<template>
  <div class="finalize">
    <Overlay />
  </div>
</template>

<script>
import Overlay from './Overlay.vue'
import donateApi from '@/api/donate'

const MAX_NUMBER_OF_STATE_FETCH_RETRIES = 5
const STATE_FETCH_RETRY_INTERVAL = 5000

export default {
  components: { Overlay },
  methods: {
    getDonationState (donationId) {
      return new Promise((resolve, reject) => {
        return donateApi.checkDonationState(donationId, function (err, res) {
          if (err) return reject(err)
          return resolve(res)
        })
      })
    },
    async pollDonationState (donationId, retries) {
      const { state } = await this.getDonationState(donationId)
      if (state === 'fail') return this.showErrorPage()
      if (state === 'await' && retries > 0) {
        return setTimeout(() => {
          return this.pollDonationState(donationId, retries - 1)
        }, STATE_FETCH_RETRY_INTERVAL)
      }

      return this.showSuccessPage()
    },
    showSuccessPage () {
      this.$store.dispatch('showStep', 'thanks')
    },
    showErrorPage () {
      this.$store.dispatch('showStep', 'error')
    }
  },
  mounted () {
    const donationId = this.$route.query.donationId
    if (donationId) {
      this.pollDonationState(donationId, MAX_NUMBER_OF_STATE_FETCH_RETRIES)
    } else {
      this.$store.dispatch('resetForm')
    }
  }
}
</script>

<style scoped>
  .finalize {
    min-height: 300px;
  }
</style>
